// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"ae160316","404":"d10973fa","498":"ae038616","787":"15907b1c"}[chunkId] + ".chunk.js";
};